<template>
    <div class="section">
        <Header class="is-uppercase has-text-weight-bold" />
        <h1 class="is-size-5 has-text-centered has-text-primary is-uppercase has-text-weight-bold">
          {{ 'Eating plan' | translate }} {{ 'Search' | translate }}
        </h1>
        <ReciptSearch @cancel="$router.push({ name: 'EatingPlan' })" />
        <hr>
        <Recipt v-for="item in $store.getters.getBySearch" :key="item.name" :data="item" />
    </div>
</template>


<script>
import Header from '@/components/Header'
import Recipt from '@/components/Settings/Recipt'
import ReciptSearch from '@/components/Settings/ReciptSearch'

export default {
  name: 'Terms',
  data () {
    return {
    }
  },
  components: {
    Recipt,
    Header,
    ReciptSearch
  }
}
</script>

<style>
.profile-column {
  width: 10rem;
}

.menu-icon {
  z-index: 999;
  opacity:0.5;
  position:absolute;
  top:0.5rem;
  right:0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Settings/ReciptFind.vue